import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import {
  hasUserAccess,
  getUserDetails,
  getUserRole,
} from "../../../../backend/auth";
import {
  useGetVendorHeirarchyRecords
} from "../../../../backend/masters";

const INCLUDE_USER_COMPANY_ASSOCIATIONS = {
  parent_company: {
    associate_companies: {
      company_location_mappings: {
        location: ['city']
      }
    }
  }
};

const ALL_OPTION = {
  value: "all",
  label: "ALL"
};

function AdminVendorLocations({ onChange, previousFilters }: any) {
  const _role = getUserRole();
  const [t] = useState(new Date().getTime());
  const [associateCompanies, setAssociateCompanies] = useState<any>(null);
  const [locations, setLocations] = useState<any>(null);
  const [categories, setCategories] = useState<any>(null);
  const [vendors, setVendors] = useState<any>(null);

  const [company, setCompany] = useState<any>(ALL_OPTION);
  const [associateCompany, setAssociateCompany] = useState<any>(ALL_OPTION);
  const [location, setLocation] = useState<any>(ALL_OPTION);
  const [category, setCategory] = useState<any>(ALL_OPTION);
  const [vendor, setVendor] = useState<any>(ALL_OPTION);
  const initialLoadComplete = useRef(false);
  const user = getUserDetails();

  const { companies, isFetching }: any = useGetVendorHeirarchyRecords({
    filters: {
      user_id_eq: user.user_id,
      is_active_eq: true
    },
    // includes: INCLUDE_USER_COMPANY_ASSOCIATIONS
  });

  useEffect(() => {
    setAssociateCompany(ALL_OPTION);
    setLocations(null);
    setLocation(ALL_OPTION);
    setCategories(null);
    setCategory(ALL_OPTION);
    setVendors(null);
    setVendor(ALL_OPTION);

    if (company && company.value !== "all") {
      const _company = companies.find((c: any) => c.id == company.value)
      if (_company) {
        setAssociateCompanies(_company.associate_companies);
      }
    } else {
      setAssociateCompanies(null);
    }
  }, [company]);

  useEffect(() => {
    setLocations(null);
    setLocation(ALL_OPTION);
    setCategories(null);
    setCategory(ALL_OPTION);
    setVendors(null);
    setVendor(ALL_OPTION);

    if (associateCompany && associateCompany.value !== "all" && company && company.value !== "all") {
      const _company = companies.find((c: any) => c.id == company.value)
      const _associateCompany = _company.associate_companies.find((c: any) => c.id == associateCompany.value)
      if (_associateCompany) {
        setLocations(_associateCompany.locations)
      }
    }
  }, [associateCompany]);

  useEffect(() => {
    setCategories(null);
    setCategory(ALL_OPTION);
    setVendors(null);
    setVendor(ALL_OPTION);

    if (location && location.value !== "all" && company && company.value !== "all" && associateCompany && associateCompany.value !== "all") {
      const _company = companies.find((c: any) => c.id == company.value)
      const _associateCompany = _company.associate_companies.find((c: any) => c.id == associateCompany.value)
      const _location = _associateCompany ? _associateCompany.locations.find((c: any) => c.id == location.value) : null
      if (_location) {
        setCategories(_location.categories)
      }
    }
  }, [location]);

  useEffect(() => {
    setVendors(null);
    setVendor(ALL_OPTION);

    if (category && category.value !== "all" && company && company.value !== "all" && associateCompany && associateCompany.value !== "all" && location && location.value !== "all") {
      const _company = companies.find((c: any) => c.id == company.value)
      const _associateCompany = _company.associate_companies.find((c: any) => c.id == associateCompany.value)
      const _location = _associateCompany.locations.find((c: any) => c.id == location.value)
      const _category = _location.categories.find((c: any) => c.id == category.value)
      if (_category) {
        setVendors(_category.vendors);
      }
    }
  }, [category]);

  useEffect(() => {
    if(companies && companies.length > 0 && !isFetching && Object.keys(previousFilters).length) {
      const _company = companies.find((as: any) => as.id == (previousFilters.company || {}).value);
      if (_company) {
        setCompany({ value: _company.id, label: _company.name });
      }
    }
  }, [companies])

  useEffect(() => {
    if (initialLoadComplete.current) return;
    if (associateCompanies && associateCompanies.length > 0 && Object.keys(previousFilters).length) {
      if (company && company.value === (previousFilters.company || {}).value) {
        const _company = associateCompanies.find((as: any) => as.id == (previousFilters.associateCompany || {}).value);
        if (_company) {
          setAssociateCompany({ value: _company.id, label: _company.name });
        }
      }
    }
  }, [associateCompanies])

  useEffect(() => {
    if (initialLoadComplete.current) return;
    if (locations && locations.length > 0 && Object.keys(previousFilters).length) {
      if (company && company.value === (previousFilters.company || {}).value &&
        associateCompany && associateCompany.value === (previousFilters.associateCompany || {}).value) {
        const _location = locations.find((as: any) => as.id == ((previousFilters.locations || [])[0] || {}).value);
        if (_location) {
          setLocation({ value: _location.id, label: _location.name });
        }
      }
    }
  }, [locations])

  useEffect(() => {
    if (initialLoadComplete.current) return;
    if (categories && categories.length > 0 && Object.keys(previousFilters).length) {
      if (company && company.value === (previousFilters.company || {}).value &&
        associateCompany && associateCompany.value === (previousFilters.associateCompany || {}).value &&
        location && location.value === ((previousFilters.locations || [])[0] || {}).value) {
        const _category = categories.find((as: any) => as.id == ((previousFilters.vendorCategories || [])[0] || {}).value);
        if (_category) {
          setCategory({ value: _category.id, label: _category.name });
        }
      }
    }
  },[categories])

  useEffect(() => {
    if (initialLoadComplete.current) return;
    if (vendors && vendors.length > 0 && Object.keys(previousFilters).length) {
      if (company && company.value === (previousFilters.company || {}).value &&
        associateCompany && associateCompany.value === (previousFilters.associateCompany || {}).value &&
        location && location.value === ((previousFilters.locations || [])[0] || {}).value &&
        category && category.value === ((previousFilters.vendorCategories || [])[0] || {}).value) {
        const _vendor = vendors.find((as: any) => as.id == ((previousFilters.vendorRegistrations || [])[0] || {}).value);
        if (_vendor) {
          setVendor({ value: _vendor.id, label: _vendor.name });
        }
        initialLoadComplete.current = true;
      }
    }
    if (!Object.keys(previousFilters).length && vendors && vendors.length > 0) {
      initialLoadComplete.current = true;
    }
  },[vendors])

  useEffect(() => {
    // Don't call onChange until companies are loaded
    if (!companies || companies.length === 0) {
      return;
    }

    const filters: any = {};
    const filterData: any = {};

    if (company && company.value === "all") {
      const allCompanyIds = (companies || []).map((c: any) => c.id);
      if (allCompanyIds.length > 0) {
        filters.company_id_in = allCompanyIds;
      }
    } else if (company && company.value !== "all") {
      filters.company_id_eq = company.value;
      filterData.company = company;
    }

    if (associateCompany && associateCompany.value !== "all") {
      filters.associate_company_id_eq = associateCompany.value;
      filterData.associateCompany = associateCompany;
    }

    if (location && location.value !== "all") {
      filters.location_id_eq = location.value;
      filterData.locations = [location];
    }

    if (category && category.value !== "all") {
      filters.vendor_category_id_eq = category.value;
      filterData.vendorCategories = [category];
    }

    if (vendor && vendor.value !== "all") {
      filters.vendor_registration_id_eq = vendor.value;
      filterData.vendorRegistrations = [vendor];
    }

    onChange(filters, filterData);
  }, [company, associateCompany, location, category, vendor, companies]);


  function selectVendor(selected: any) {
    if(selected.value === vendor.value) {
      return
    } else {
      setVendor(selected);
    }
  }

  return (
    <>
      <div className="px-2">
        <label className="filter-label">
          <small>Company</small>
        </label>
        <Select
          placeholder="Company"
          options={[
            ALL_OPTION,
            ...(companies || []).map((x: any) => {
              return { value: x.id, label: x.name };
            })
          ]}
          onChange={setCompany}
          value={company}
          className="select-control"
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Associate Company</small>
        </label>
        <Select
          placeholder="Associate Company"
          options={
            Array.isArray(associateCompanies)
              ? [
                  ALL_OPTION,
                  ...associateCompanies.map((x: any) => ({
                    value: x.id,
                    label: x.name,
                  }))
                ]
              : [ALL_OPTION]
          }
          onChange={setAssociateCompany}
          value={associateCompany}
          className="select-control"
          isDisabled={!company || company.value === "all"}
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Location</small>
        </label>
        <Select
          placeholder="Location"
          options={
            Array.isArray(locations)
              ? [
                  ALL_OPTION,
                  ...locations.map((x: any) => ({
                    value: x.id,
                    label: x.name,
                  }))
                ]
              : [ALL_OPTION]
          }
          onChange={setLocation}
          value={location}
          className="select-control"
          isDisabled={!associateCompany || associateCompany.value === "all"}
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Vendor Category</small>
        </label>
        <Select
          placeholder="Category"
          options={
            Array.isArray(categories)
              ? [
                  ALL_OPTION,
                  ...categories.map((x: any) => {
                    return { value: x.id, label: x.name };
                  })
                ]
              : [ALL_OPTION]
          }
          onChange={setCategory}
          value={category}
          className="select-control"
          isDisabled={!location || location.value === "all"}
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Vendor</small>
        </label>
        <Select
          placeholder="Vendors"
          options={
            Array.isArray(vendors)
              ? [
                  ALL_OPTION,
                  ...vendors.map((x: any) => ({
                    value: x.id,
                    label: x.name,
                  }))
                ]
              : [ALL_OPTION]
          }
          onChange={selectVendor}
          value={vendor}
          className="select-control"
          isDisabled={!category || category.value === "all"}
        />
      </div>
    </>
  );
}

export default AdminVendorLocations;
